import ProfileAvatar, { ProfileAvatarProps } from './ProfileAvatar';

export type { ProfileAvatarProps };
export default ProfileAvatar;
